import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {WorkflowInstanceDTO} from '../../core/dtos/workflow-instance-dto';
import {LigneLivraisonImpossibleDTO} from '../../core/dtos/gestion-fournisseur/ligne-livraison-impossible-dto';
import {WorkflowsService} from '../../core/services/entities/workflows.service';
import {UtilsService} from '../../core/utils/utils.service';
import {RunStepDTO} from '../../core/dtos/run-step-dto';
import {MenuItem} from 'primeng/api';
import {ErreurFonctionnelleDto} from '../../core/dtos/erreur-fonctionnelle-dto';
import {sortBy as _sortBy} from 'lodash'
import {Subscription} from 'rxjs';
import {MSG_KEY, MSG_SEVERITY} from '../../core/constants';
import {ToastService} from "../../core/services/technique/toast.service";
import {NextStepConfirmationDto, NextStepConfirmationEnum} from "../../core/dtos/next-step-confirmation-dto";
import {confirm} from "devextreme/ui/dialog";
import {FermeturePoncutelleService} from "../../core/services/entities/fermeture-poncutelle.service";
import {FermeturePonctuelleFilter} from "../../core/dtos/fermeture-ponctuelle/FermeturePonctuelleFilter";
import {ButtonThemeEnum} from "../../shared/ui/button/button-theme-enum";


@Component({
    selector: 'yo-button-next-steps',
    templateUrl: './button-next-steps.component.html',
    styleUrls: ['./button-next-steps.component.scss'],
    standalone: false
})
export class ButtonNextStepsComponent implements OnInit, OnDestroy {

  subWorkflowInstance: Subscription;

  nextStepItems: MenuItem[];
  uniqueId: string;

  displayDialogPassageCommande: boolean = false;
  listeBesoinEnErreur: boolean = true;
  lbErreurs: number;
  continueWithErrorsToPassageCommande: boolean = false;
  lbdActifs: number;

  displayDialogLivraisonImpossible: boolean = false;
  livraisonImpossibleList: LigneLivraisonImpossibleDTO[] = [];
  private pendingWorkflowInstance: WorkflowInstanceDTO;

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  @Input() id: string;

  @Input() workflowInstance: WorkflowInstanceDTO;

  // objet d'entree necessaire à la tache courante pour son fonctionnement
  @Input() runInput: any;
  @Input() play: boolean; // true : button play en haut ; false : button suivant en bas
  @Input() nextStepConfirmation: NextStepConfirmationDto = new NextStepConfirmationDto();

  @Output() onError = new EventEmitter();

  constructor(public workflowSvc: WorkflowsService,
              private cd: ChangeDetectorRef,
              public utils: UtilsService,
              private toastSvc: ToastService,
              private fermeturePonctuelleSvc: FermeturePoncutelleService) {
  }

  ngOnInit() {
    this.uniqueId = this.id !== undefined ? this.id : `actionButton_${this.workflowInstance?.id || Math.random()}`;
    this.nextStepItems = this.createMenuItems(this.workflowInstance);
    this.subscriptionWorkflowInstance();
  }

  ngOnDestroy() {
    this.utils.unsubscribe(this.subWorkflowInstance);
  }

  subscriptionWorkflowInstance(){
    this.subWorkflowInstance = this.workflowSvc.workflowInstance$.subscribe(workflowInstance => {
      this.workflowInstance = workflowInstance;
      this.nextStepItems = this.createMenuItems(this.workflowInstance);
      this.cd.markForCheck();
    });
  }

  /**
   * Creer les etapes
   * @param workflowInstance
   */
  createMenuItems(workflowInstance: WorkflowInstanceDTO): MenuItem[] {
    const items = [];
    if (!this.utils.isCollectionNullOrEmpty(workflowInstance.nextSteps)) {
      workflowInstance.nextSteps = _sortBy(workflowInstance.nextSteps, 'niveau');
      for (let nextStep of workflowInstance.nextSteps) {
        const stepItem = {
          label: nextStep.workflowStatutLibelle.toUpperCase(),
          icon: nextStep.niveau <= workflowInstance.niveauWorkflowEtape ? 'fas fa-backward' : 'fas fa-forward space',
          command: (): void => {
            this.goToNextStepSpec(workflowInstance, nextStep.workflowStatutCode, this.runInput)
          }
        };
        items.push(stepItem);
      }
    }
    return items;
  }


  /**
   * Lancer le calcul de la commande fournisseur
   * @param wi
   */
  goToCommande(wi: WorkflowInstanceDTO) {
    if (this.lbdActifs < 1) {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.WARNING, `Vous ne pouvez pas passer la commande car aucun article n'a été sélectionné`);
    } else {
      // lancer l'étape de calcul de commandes fournisseurs,
      this.goToNextStep(wi, 'calcul-commandes-fournisseurs', undefined);
    }
  }


  /**
   * Aller à l'étape suivante du workflow
   * Gere le cas particulier du besoin vers la commande
   * @param wi
   * @param nextStep
   * @param runInput
   */
  async goToNextStepSpec(wi: WorkflowInstanceDTO, nextStep: string, runInput: any) {
    this.displayDialogPassageCommande = false
    if (this.nextStepConfirmation.typeConfirmation === NextStepConfirmationEnum.LISTE_BESOINS_FERMETURES_PONCTUELLES) {
      const filter = new FermeturePonctuelleFilter();
      filter.idWorkflowInstance = wi.id;
      filter.perimetre = 'APPROVISIONNEMENT';
      this.fermeturePonctuelleSvc.getFermeturePonctuelleByListeBesoin(filter).subscribe(async response => {
        const fermeturePonctuelleList: [] = response;
        if (fermeturePonctuelleList.length > 0) {
          confirm(this.nextStepConfirmation.message, this.nextStepConfirmation.title).then(result => {
            if (result) {
              this.goToNextStep(wi, nextStep, runInput);
            }
          })
        } else{
          this.goToNextStep(wi, nextStep, runInput);
        }
      })
    } else {
      this.goToNextStep(wi, nextStep, runInput);
    }
  }


  createRunStep(workflowInstance: WorkflowInstanceDTO, nextStepCode: string, runInput: any): RunStepDTO {
    const runStep = new RunStepDTO();
    runStep.idWorkflowInstance = workflowInstance.id;
    runStep.nextStepCode = nextStepCode;
    runStep.recompute = this.workflowSvc.isTaskToRecompute(workflowInstance.codeWorkflowStatut);
    runStep.runInput = runInput;

    return runStep;
  }

  /**
   * Passer à l'étape suivante du workflow
   * @param workflowInstance
   * @param nextStep
   * @param runInput
   */
  goToNextStep(workflowInstance: WorkflowInstanceDTO, nextStep: string, runInput: any) {

    const runStep = this.createRunStep(workflowInstance, nextStep, runInput);

    this.workflowSvc.goToNextStep(runStep).subscribe(response => {

      if(response){
        if (!this.utils.isNullOrEmpty(response.additionalProperties['erreurs'])) {
          // s'il y a des erreurs de validation sur la tâche, on notifie l'utilisateur
          let erreurs: ErreurFonctionnelleDto[] = response.additionalProperties['erreurs'];

          if (!this.utils.isCollectionNullOrEmpty(erreurs)) {
            this.onError.emit(erreurs);
          }
        }

        const wi = response.one;
        this.displayDialogPassageCommande = false;

        const livraisonImpossible = wi?.ligneLivraisonImpossibleList;
        if (!this.utils.isCollectionNullOrEmpty(livraisonImpossible)) {
          this.pendingWorkflowInstance = wi;
          this.livraisonImpossibleList = livraisonImpossible;
          this.displayDialogLivraisonImpossible = true;
        } else {
          this.workflowSvc.announceWorkflowInstance(wi);
          this.workflowSvc.openTask(wi);
        }
      }
    });
  }

  closeLivraisonImpossibleDialog() {
    this.displayDialogLivraisonImpossible = false;
    this.workflowSvc.announceWorkflowInstance(this.pendingWorkflowInstance);
    this.workflowSvc.openTask(this.pendingWorkflowInstance);
  }
}
